export * from './panel.component';

import {Panel} from './panel.component';
import {PanelHeader} from './panel.header.component';

export const PANEL_COMPONENTS = [
    Panel,
    PanelHeader
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/panel/index.ts